<template>
    <div class="contain">
        <div style="height: 10px; background-color: #f2f2f2"></div>
        <div class="list" v-for="(item,index) in newsList" :key="index">
            <div class="tr">
                <img class="newsIcon" src="../assets/news.png" alt="">
                <!-- <img class="newsIcon" :src="imgUrl2 + item.msmtPicture" alt=""> -->
                <div class="notice">{{item.msmtTitle}}</div>
                <div class="time">{{item.adddate}}</div>
            </div>
            <div>{{item.msmtInfo}}</div>
            <div class="xian"></div>
            <div class="viewDetails" @click="goMessagePage(item.id)">
                <div>查看详情</div>
                <img class="youIcon" src="../assets/you.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";

export default {
    data() {
        return {
            newsList:[]
        }
    },
    created() {
        let param = {
            WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
            // WorkerID: '453246',
        };
        this.$post('api/Notification/SelectNotification', qs.stringify(param),{
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res =>{
            console.log(res.data);
           this.newsList = res.data
        })
    },
    methods: {
        goMessagePage(id) {
            this.$router.push({ path: "/messagePage", query: {mid: id}, meta: { title: '便民资讯' }})
        }
    }
}
</script>

<style scoped>
.contain {
    background: #f2f2f2;
    min-height: 100vh;
    padding: 0 12px;
}
.list {
    /* width: 351px; */
    background: #FFF;
    margin:  0 auto 0;
    padding: 15px 10px 10px;
    box-sizing: border-box;
    border-radius: 5px;
    margin-bottom: 10px;
}
.newsIcon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-top: 5px;
}
.tr {
    display: flex;
    line-height: 30px;
    position: relative;
}
.notice {
    font-size: 16px;
    font-weight: 700;
}
.time {
    font-size: 11px;
    color: #999;
    position: absolute;
    right: 0;
}
.xian {
    border-bottom: 1px solid #E6E6E6 ;
    margin: 15px 0 10px;
}
.viewDetails {
    display: flex;
    justify-content: space-between;
}
.youIcon {
    width: 20px;
    height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/page/news.vue